export default __webpack_public_path__ + "static/media/profile-info.1b08cd92.pdf";